import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'
import { getSharedContent } from '@/lib/share-receiver'

/**
 * Listens for incoming share intents (Android) and URL scheme opens (iOS).
 * When shared content is detected, navigates to /quick-capture.
 * Should be mounted once inside a Router context (e.g. in AppShell or a top-level wrapper).
 */
export function useShareReceiver() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return

    // iOS: listen for URL scheme opens (aime://quick-capture)
    const urlListener = App.addListener('appUrlOpen', (event) => {
      if (event.url.includes('quick-capture')) {
        navigate('/quick-capture')
      }
    })

    // Android: check for shared data on app resume
    const resumeListener = App.addListener('appStateChange', (state) => {
      if (state.isActive && location.pathname !== '/quick-capture') {
        getSharedContent().then((content) => {
          if (content.type !== 'none') {
            navigate('/quick-capture')
          }
        })
      }
    })

    // Also check on initial mount (cold start with share intent)
    getSharedContent().then((content) => {
      if (content.type !== 'none') {
        navigate('/quick-capture')
      }
    })

    return () => {
      urlListener.then((l) => l.remove())
      resumeListener.then((l) => l.remove())
    }
  }, [navigate, location.pathname])
}
